export default __webpack_public_path__ + "static/studielan-post-c15325f42fb625d3c5135fc794b26ab8.png";